function aspect_ratio(selector, x, y, innerHeight=false) {
    let elements = document.querySelectorAll('.'+selector);
    Array.prototype.slice.call(elements)
        .forEach(function (element) {
            console.log(element.offsetWidth);
            let w = element.offsetWidth;
            let ratio = w*y/x;
            element.style.height = parseInt(ratio)+'px';

            if (innerHeight) {
                //element.querySelector('.set_inner_banner').style.height = parseInt(ratio)+'px';
            }

        })
}
export { aspect_ratio }
